import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import User from '../../_common_user/ManageUser';
import useQuery from './useQuery';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import SleepingStarting from '../../_common_user/User/SleepingStarting';
import SleepingEnding from '../../_common_user/User/SleepingEnding';
import InactiveStarting from '../../_common_user/User/InactiveStarting';

export default function Layout(props) {
  const { location } = useRouter();
  const launch = useDialogLauncher();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    location,
    PAGE_SIZE,
    returnRawQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Partners']}
      title="Inactive Partners"
      description={(
        <span>
          These are partners who have been marked as inactive, typically due to a non-existent
          email address of a history of not responding to invitations and messages. They
          are not able to log in and use the platform without having their account reactivated.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      csvQuery={function () {
        onDownload(csvQuery);
      }}
      row={function(user) {
        return (
          <User key={user.id} user={user}>
            <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100">
              <div className="grid grid-cols-2">
                <InactiveStarting user={user} />
              </div>
            </div>
          </User>
        );
      }}
    />
  );
}
